import React, { useCallback } from 'react';

import Selector from '../../../elements/selector';
import { ShapeEnum } from 'ud-ui/components/fabric-canvas/addons/placeholders/complex/team-period-fouls';
import UDText from 'ud-ui/components/text';
import history from 'ud-ui/components/fabric-canvas/addons/history';
import { selectFabricManager } from '../../../../../store/editor/selectors';
import { useSelector } from 'react-redux';

interface IProps {
  onChange: (shape: ShapeEnum) => void;
  value: ShapeEnum;
}

function ChoosingShape(props: IProps) {
  const { onChange, value } = props;
  const manager = useSelector(selectFabricManager);

  const onFocusField = useCallback(() => {
    manager?.render();
    history.saveState();
  }, [manager]);

  return (
    <>
      <UDText type={'caption-1'}>Форма индикатора</UDText>
      <Selector
        onFocus={onFocusField}
        onChange={(event) => {
          onChange(event?.value);
        }}
        options={options}
        value={options.find((option) => option.value === value)}
      />
    </>
  );
}

export default ChoosingShape;

const options = [
  { label: 'Круг', value: ShapeEnum.CIRCLE },
  { label: 'Прямоугольник', value: ShapeEnum.RECTANGLE },
];
